import React, { useEffect, useState } from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  NavItem,
  NavLink,
} from 'reactstrap';
import { Spin } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { LogoutUser, DestroyAppliedJobs } from '../actions';
import { reqPostLogout } from '../axios/api';

const UserDropdown = (props) => {

  const Auth = useSelector(state => state.Auth);
  const history = useHistory();
  const dispatch = useDispatch();

  const [candidateObj, setCandidateObj] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("candidate") !== undefined && sessionStorage.getItem("candidate") !== null) {
      setCandidateObj(true);
    } else {
      setCandidateObj(false);
    }

  }, [Auth.isLoggedIn]);

  const handleLogout = () => {
    // Log the UI out first (so no candidate-scoped calls fire), THEN revoke the httpOnly cookie.
    dispatch(LogoutUser());
    dispatch(DestroyAppliedJobs());
    sessionStorage.removeItem("candidate");
    history.push('/');
    reqPostLogout();
  }

  const LoggedIn = () => {
    return (
      <>
        <Dropdown nav isOpen={!props.collapsedUser} toggle={props.toggleUserDropDown}>
          <DropdownToggle nav caret>
            <i className="fa fa-user-o"></i> {" "}
            {Auth.firstName + " " + Auth.lastName}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => { history.push("/profile") }}>My Profile</DropdownItem>
            <DropdownItem onClick={() => { history.push("/offers") }}>My Offers</DropdownItem>
            <DropdownItem onClick={() => { history.push("/pre-onboarding") }}>Pre-Onboarding</DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => { history.push("/settings") }}>Settings</DropdownItem>
            {/**<DropdownItem divider />**/}
            <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </>
    );
  }

  const LoginButton = () => {
    return (
      <>
        {
          candidateObj ? (
            <Spin style={{ marginTop: "10px", marginLeft: "10px" }} />
          ) : (
            <NavItem>
              <NavLink tag={Link} className="btn btn-danger text-light" style={{ background: "#ff4d4f" }} to="/login">Sign In</NavLink>
            </NavItem >
          )
        }

      </>
    );
  }

  return (
    <>
      {(!Auth.isLoggedIn) ? <LoginButton /> : <LoggedIn />}
    </>
  );
}

export default UserDropdown;

